import { SET_TIMELINE_LOADING, GET_TIMELINE_DATA, CLEAR_TIMELINE_DATA } from './types'

const initialState = {
  activitiesTimelineData: [],
  query: {
    first: 0,
    limit: 10,
    totalRecords: 0,
    hasMore: true,
    isRefresh: false,
  },
  isLoading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TIMELINE_LOADING:
      return {
        ...state,
        isLoading: !state.isLoading,
      }

    case GET_TIMELINE_DATA:
      return {
        ...state,
        activitiesTimelineData: action.payload.query.isRefresh
          ? [...action.payload.data]
          : [...state.activitiesTimelineData, ...action.payload.data],
        query: action.payload.query,
        isLoading: false,
      }
    case CLEAR_TIMELINE_DATA:
      return { ...state, activitiesTimelineData: [], query: initialState.query }
    default:
      return state
  }
}
